function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg094Bhutan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF9811"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFDA44"
    },
    points: "512,0 0,0 0,512 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M352.546,181.797v-29.682h-56.891l-4.346,4.346c-15.459,15.459-12.859,33.494-10.96,46.662  c1.761,12.216,1.972,16.894-2.57,21.437c-4.542,4.542-9.223,4.331-21.437,2.57c-13.167-1.898-31.202-4.499-46.661,10.959  c-15.458,15.459-12.857,33.493-10.957,46.66c1.762,12.213,1.973,16.893-2.568,21.434c-4.542,4.54-9.223,4.329-21.434,2.568  c-4.762-0.687-9.686-1.397-14.94-1.455l-0.326,29.679c3.289,0.037,7.049,0.579,11.029,1.152c4.712,0.68,10.045,1.45,15.663,1.45  c5.821,0,11.945-0.83,17.993-3.442v23.747h44.522v-22.261h-22.261v-14.84h14.84v-22.261H229.38  c0.563-7.201-0.426-14.097-1.28-20.009c-1.762-12.213-1.973-16.893,2.568-21.434c4.542-4.542,9.222-4.332,21.437-2.57  c9.594,1.384,21.774,3.131,33.658-1.999v23.751h44.522V256h-22.261v-14.84h14.84v-22.261h-11.861  c0.563-7.202-0.425-14.097-1.278-20.011c-1.23-8.534-1.704-13.39-0.329-17.091H352.546z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg094Bhutan);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0ZGOTgxMTsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+Cjxwb2x5bGluZSBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSI1MTIsMCAwLDAgMCw1MTIgIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBkPSJNMzUyLjU0NiwxODEuNzk3di0yOS42ODJoLTU2Ljg5MWwtNC4zNDYsNC4zNDZjLTE1LjQ1OSwxNS40NTktMTIuODU5LDMzLjQ5NC0xMC45Niw0Ni42NjIgIGMxLjc2MSwxMi4yMTYsMS45NzIsMTYuODk0LTIuNTcsMjEuNDM3Yy00LjU0Miw0LjU0Mi05LjIyMyw0LjMzMS0yMS40MzcsMi41N2MtMTMuMTY3LTEuODk4LTMxLjIwMi00LjQ5OS00Ni42NjEsMTAuOTU5ICBjLTE1LjQ1OCwxNS40NTktMTIuODU3LDMzLjQ5My0xMC45NTcsNDYuNjZjMS43NjIsMTIuMjEzLDEuOTczLDE2Ljg5My0yLjU2OCwyMS40MzRjLTQuNTQyLDQuNTQtOS4yMjMsNC4zMjktMjEuNDM0LDIuNTY4ICBjLTQuNzYyLTAuNjg3LTkuNjg2LTEuMzk3LTE0Ljk0LTEuNDU1bC0wLjMyNiwyOS42NzljMy4yODksMC4wMzcsNy4wNDksMC41NzksMTEuMDI5LDEuMTUyYzQuNzEyLDAuNjgsMTAuMDQ1LDEuNDUsMTUuNjYzLDEuNDUgIGM1LjgyMSwwLDExLjk0NS0wLjgzLDE3Ljk5My0zLjQ0MnYyMy43NDdoNDQuNTIydi0yMi4yNjFoLTIyLjI2MXYtMTQuODRoMTQuODR2LTIyLjI2MUgyMjkuMzggIGMwLjU2My03LjIwMS0wLjQyNi0xNC4wOTctMS4yOC0yMC4wMDljLTEuNzYyLTEyLjIxMy0xLjk3My0xNi44OTMsMi41NjgtMjEuNDM0YzQuNTQyLTQuNTQyLDkuMjIyLTQuMzMyLDIxLjQzNy0yLjU3ICBjOS41OTQsMS4zODQsMjEuNzc0LDMuMTMxLDMzLjY1OC0xLjk5OXYyMy43NTFoNDQuNTIyVjI1NmgtMjIuMjYxdi0xNC44NGgxNC44NHYtMjIuMjYxaC0xMS44NjEgIGMwLjU2My03LjIwMi0wLjQyNS0xNC4wOTctMS4yNzgtMjAuMDExYy0xLjIzLTguNTM0LTEuNzA0LTEzLjM5LTAuMzI5LTE3LjA5MUgzNTIuNTQ2eiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };